import OptInModal from './OptInModal.vue';

export default OptInModal;